import React from "react";
import { makeStyles } from "@material-ui/styles";
import { experimentalStyled as styled } from "@material-ui/core/styles";

// material
import {
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { useGetComisionesEmpleadoQuery } from "src/services/empleadosApi";

const styles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginTop: 20,
  },
}));

export default function FacturaTareasEmpleado(props) {
  const { value, empleado } = props;
  const classes = styles();
  const { data: comisiones = [] } = useGetComisionesEmpleadoQuery({
    rut: empleado.rut,
    nombreCompleto: `${empleado.nombre} ${empleado.apellidos}`,
  });

  const RootStyle = styled("div")(({ theme }) => ({
    marginTop: "1rem",
  }));

  return (
    <>
      {value === 5 && (
        <Card>
          <Typography variant="h5" component="h2" className={classes.title}>
            Comisiones del Empleado
          </Typography>
          <RootStyle>
            <Card style={{ padding: "1rem" }}>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Cargo</TableCell>
                      <TableCell>Comisión</TableCell>
                      <TableCell>Nombre Tarea</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {comisiones &&
                      comisiones.map((row, idx) => {
                        return (
                          <TableRow key={"facturasAsociadas_" + idx}>
                            <TableCell component="th" scope="row">
                              {row.tipoCargo}
                            </TableCell>
                            <TableCell>{row.comision} %</TableCell>
                            <TableCell>{row.nombreTarea}</TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </RootStyle>
        </Card>
      )}
    </>
  );
}
